import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import CtaButtonSecondary from './cta-button-secondary'
import { t } from '../../core/i18n'

const goToAutomaticBidFunction = (history, id) => () =>
  history.push(`items/${id}/bid`)

const AutomaticBidCtaButton = props => {
  const { id, history, isActive, disabled } = props
  return (
    <CtaButtonSecondary
      onClick={goToAutomaticBidFunction(history, id)}
      hasIcon
      iconName='bid'
      text={t('button.automaticBidOptions')}
      multiline
      isActive={isActive}
      disabled={disabled}
    />
  )
}

AutomaticBidCtaButton.defaultProps = {
  isActive: true,
  disabled: false
}

AutomaticBidCtaButton.propTypes = {
  id: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool
}

export default withRouter(AutomaticBidCtaButton)



// WEBPACK FOOTER //
// ./src/ui/buttons/AutomaticBidCtaButton.js